"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClipboardCopy = void 0;
var clipboard_copy_1 = __importDefault(require("clipboard-copy"));
var react_1 = require("react");
var SnackbarHooks_1 = __importDefault(require("../snackbar/SnackbarHooks"));
var useClipboardCopy = function (_a) {
    var _b = _a === void 0 ? {} : _a, successSnack = _b.successSnack;
    var enqueueSuccessSnack = SnackbarHooks_1.default.useCurriedSnackbar().enqueueSuccessSnack;
    return (0, react_1.useCallback)(function (content) {
        void (0, clipboard_copy_1.default)(content);
        successSnack && enqueueSuccessSnack(successSnack);
    }, [enqueueSuccessSnack, successSnack]);
};
exports.useClipboardCopy = useClipboardCopy;
var clipboardHooks = {
    useClipboardCopy: exports.useClipboardCopy,
};
exports.default = clipboardHooks;
